export default "__VITE_ASSET__BVSpzF1$__"